import { Component, EventEmitter, input, Output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { TpOwnerResponse } from "../../../models";
import { PictureComponent, ProgressIndicatorComponent } from "../../general";

@Component({
  selector: "adaa-tp-owner",
  imports: [TranslatePipe, TranslateTokenPipe, ProgressIndicatorComponent, PictureComponent],
  templateUrl: "./tp-owner.html",
  styleUrl: "./tp-owner.scss",
})
export class TpOwnerComponent {
  owner = input.required<TpOwnerResponse>();

  @Output() cardClicked = new EventEmitter<number[]>();
}
